import { NgModule } from '@angular/core';

import { TranslationComponent } from './translation.component';
import { TranslationDirective } from './translation.directive';
import { TranslationPipe } from './translation.pipe';
import { TranslationService } from './translation.service';

@NgModule({
  declarations: [
      TranslationComponent,
      TranslationDirective,
      TranslationPipe,
  ],
  exports: [
      TranslationComponent,
      TranslationDirective,
      TranslationPipe,
  ],
  providers: [
      TranslationService
  ],
})
export class TranslationModule
{ }

/**
 * TranslationDirective
 * It is mainly used for static translations in non-Angular (Material) elements.
 * Angular Material does crazy things with elements like <mat-card-title>
 * This applies to tags like <ng-template> or <ng-container>.
 * It's because the innerHTML is replaced with the respective translated text.
 *
 * Usage:
 *   <span translate>i18n.button.apply</translate>
 *   <span translate>5 i18n.button.apply</translate>
 *
 *
 * TranslationPipe
 * It is mainly used for translations with replacements (e.g. listing) or
 * changeable plural-values (e.g. "x of y images uploaded").
 * In addition they are usable in Angular (Material) elements without any
 * known problems.
 *
 * Usage:
 *   {{'i18n.button.apply' | translate}}
 *   {{'i18n.button.apply' | translate:5}}
 *   {{'i18n.button.apply' |
 *     translate:5:{'firstName': 'John', lastName: 'Doe'}}}
 *
 *
 * TranslationComponent
 * It has the same functionality as TranslationPipe but is more clearer if
 * replacements or changing plural forms are used
 *
 * Usage:
 *   <translate [key]="'i18n.button.apply'"
 *              [plural]="5"
 *              [values]="{'firstName': 'John', lastName: 'Doe'}"
 *   ></translate>
 */



// WEBPACK FOOTER //
// ./src/app/core/translation/translation.module.ts